import { render, staticRenderFns } from "./DevelopmentProperty.vue?vue&type=template&id=d1667fa6&scoped=true&"
import script from "./DevelopmentProperty.vue?vue&type=script&lang=js&"
export * from "./DevelopmentProperty.vue?vue&type=script&lang=js&"
import style0 from "./DevelopmentProperty.vue?vue&type=style&index=0&id=d1667fa6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1667fa6",
  null
  
)

export default component.exports